import {
  Button,
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
} from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { getServices } from "../../apiServices/apiServices";
import LoadingGif from "../../assets/loading_anim.gif";
import { jwtDecode } from "jwt-decode";
// import ManifoldReportTable from "../../components/common/ManifoldReportTable";
import { MdOutlineMoreVert } from "react-icons/md";
import EmptyingReport from "../reports/EmptyingReport";

function SubControllerDetails() {
  const [controllerDetails, setControllerDetails] = useState({});
  const [manifoldReportData, setManifoldReport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hardwareId, setHardwareId] = useState("");
  const navigate = useNavigate();
  const access_token = localStorage.getItem("gassol-sub-branch-token");
  const decoded = jwtDecode(access_token);
  // const ws = new WebSocket("ws://user.gassol.in:7935");

  useEffect(() => {
    if (!localStorage.getItem("gassol-sub-branch-token")) {
      navigate("/sign_in");
    }

    window.scrollTo(0, 0);

    // const ws = new WebSocket("ws://15.207.40.24:7878");
    // const ws = new WebSocket("wss://user.gassol.in/ws");
    // // const ws = new WebSocket("ws://192.168.0.185:8080");

    // ws.onmessage = (event) => {
    //   const data = JSON.parse(event.data);
    //   // Update your UI with the new data
    //   console.log(data);
    //   setControllerDetails(data);
    // };

    // ws.onopen = () => {
    //   console.log("Connected to WebSocket server");

    //   ws.send(
    //     // `${base_url}/api/hardware/data?hardware_id=${location.state.hardware_id}`
    //     "hi"
    //   );
    // };

    // ws.onerror = (err) => {
    //   console.log(err);
    // };

    // ws.onclose = () => {
    //   console.log("Disconnected from WebSocket server");
    // };

    // fetchHourlyBurnerReport(true, null);
    fetchManifoldReportData(true);

    // const interval = setInterval(() => {+
    //   fetchControllerDetails(false);
    // }, 30000);

    // return () => clearInterval(interval);
  }, [navigate]);

  const fetchControllerDetails = async (hardware_id) => {
    setLoading(true);

    try {
      const res = await getServices(
        `/api/hardware/data?hardware_id=${hardware_id}`
      );
      setLoading(false);
      // console.log(res);

      if (res.responseCode === 200) {
        setControllerDetails(res.responseData[0]);
      } else {
        setControllerDetails({});
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };
  const fetchManifoldReportData = async (load_bool) => {
    setLoading(load_bool);
    try {
      const res = await getServices(
        `/api/device/manifold/runtime?branch_id=${decoded.id}`,
        access_token
      );

      setLoading(false);

      if (res.responseCode === 200) {
        setHardwareId(res.responseData?.[0]?.id);
        setManifoldReport(res.responseData?.data);
        fetchControllerDetails(res.responseData?.data?.[0]?.id);
      } else {
        setManifoldReport([]);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("gassol-sub-branch-token");
    navigate("/sign_in");
  };

  return (
    <>
      <div className="py-4 md:py-8 max-w-[1400px] mx-auto px-3">
        {!loading ? (
          <>
            <div className="flex gap-2 justify-between items-center flex-row">
              <div className="flex gap-3 sm:gap-6">
                <div className="flex gap-2 items-center font-semibold text-xl text-[#BDBDBD]">
                  {/* <IoChevronBackOutline /> */}
                  <p>Controller Details</p>
                </div>
              </div>
              <Button
                className="font-poppins bg-[#03438D] font-medium tracking-widest"
                onClick={handleLogout}
              >
                Logout
              </Button>
            </div>

            <div className="flex flex-col md:flex-row justify-between md:items-center gap-3 sm:gap-2 mt-4 md:mt-8">
              <div>
                <p className="text-[#BDBDBD] text-sm">Hardware Name</p>
                <p className="text-black font-bold text-4xl">Switch Right</p>
              </div>

              <div className="flex gap-3 ml-auto">
                {/* <Button
                  onClick={() => {
                    window.open(
                      `/controller_details/burner_report/${controllerDetails.branch}`,
                      "_blank"
                    );
                  }}
                  className="font-poppins font-medium tracking-wider bg-[#03438D]"
                >
                  Burner Report
                </Button>
                <Button
                  onClick={() => {
                    window.open(
                      `/controller_details/cylinder_weight_report/${controllerDetails.branch}`,
                      "_blank"
                    );
                  }}
                  className="font-poppins font-medium tracking-wider bg-[#03438D]"
                >
                  Cylinder Report
                </Button> */}
                {controllerDetails?.reportInfo?.[0]?.gld_report !== 0 && (
                  <Button
                    onClick={() => {
                      navigate(`/sub_branch/controller_details/gld_logs`, {
                        state: { hardware_id: hardwareId },
                      });
                    }}
                    className="font-poppins font-medium tracking-wider bg-[#03438D]"
                  >
                    Gld Logs
                  </Button>
                )}

                <Menu placement="left-start">
                  <MenuHandler title="Click to open reports">
                    <Button className="p-2 rounded-full bg-[#03438D] outline-none">
                      <MdOutlineMoreVert className="text-2xl" />
                    </Button>
                  </MenuHandler>
                  <MenuList>
                    {controllerDetails?.reportInfo?.[0]?.br_report === 1 && (
                      <MenuItem
                        onClick={() => {
                          window.open(
                            `/controller_details/burner_report/${controllerDetails.branch}`,
                            "_blank"
                          );
                        }}
                        className="font-poppins"
                      >
                        Burner Report
                      </MenuItem>
                    )}
                    <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/cylinder_weight_report/${controllerDetails.branch}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Cylinder Report
                    </MenuItem>
                    {/* <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/emptying_report/${controllerDetails.branch}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Emptying Report
                    </MenuItem> */}
                    <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/offline_report/${controllerDetails.branch}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Offline Report
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/offtime_report/${controllerDetails.branch}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Off-time Report
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        window.open(
                          `/controller_details/graph_view/${controllerDetails.branch}`,
                          "_blank"
                        );
                      }}
                      className="font-poppins"
                    >
                      Graph View
                    </MenuItem>
                  </MenuList>
                </Menu>
              </div>
            </div>

            {/* manifold report */}
            {/* {manifoldReportData.length > 0 ? ( */}
            {controllerDetails ? (
              <>
                {/* <ManifoldReportTable
                  manifoldReportData={manifoldReportData}
                  controllerDetails={controllerDetails}
                /> */}
                <EmptyingReport branch_id={controllerDetails.branch} />
              </>
            ) : (
              <div className="text-center h-[50vh] flex flex-col justify-center items-center text-black">
                <p className="font-semibold text-xl sm:text-3xl">
                  Oops! No Data Found...
                </p>
                <p className="text-sm mt-2 ">
                  Looks like we couldn't find any branch that match your search
                  right now.
                </p>
              </div>
            )}
          </>
        ) : (
          <div className="w-full flex justify-center items-center h-[90vh]">
            <img src={LoadingGif} alt="" />
          </div>
        )}
      </div>
    </>
  );
}

export default SubControllerDetails;
